import { render, staticRenderFns } from "./AMCAdd.vue?vue&type=template&id=59b77d2c&scoped=true"
import script from "./AMCAdd.vue?vue&type=script&lang=js"
export * from "./AMCAdd.vue?vue&type=script&lang=js"
import style0 from "./AMCAdd.vue?vue&type=style&index=0&id=59b77d2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b77d2c",
  null
  
)

export default component.exports